import { useState } from 'react'
import { DropMenuItemId } from 'blocks.simple/dropMenu/dropMenu.types'

export const useActionBar = () => {
    const [activeElements, setActiveElements] = useState<DropMenuItemId[]>([])

    return {
        activeElements,
        setActiveElements,
    }
}

export const useUploadDelimeter = (defaultDelimeter: string = '') => {
    const [delimiter, setDelimiter] = useState<string>(defaultDelimeter)

    return {
        delimiter,
        setDelimiter,
    }
}
